/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { JobsPage } from '@/pages/Jobs/JobsPage';

export function JobsRoute() {
  return <JobsPage />;
}
